import { render } from "./fibreSelect.vue?vue&type=template&id=2dad7b1e"
import script from "./fibreSelect.vue?vue&type=script&lang=js"
export * from "./fibreSelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__